// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gab-02 .banner-container .icon__container{margin-top:1em;margin-bottom:1em;margin-left:40px;margin-right:40px}", ""]);
// Exports
module.exports = exports;
